import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './../services/auth.service';

export default function PrivateRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="p-6 text-center text-gray-500">Chargement…</div>;
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}